import { SeatMap } from "@duffel/api/types";

export function hasAvailableSeatService(seatMaps?: SeatMap[]): boolean {
  if (!Array.isArray(seatMaps) || seatMaps.length === 0) return false;

  for (const seatMap of seatMaps) {
    for (const cabin of seatMap.cabins) {
      for (const rows of cabin.rows) {
        for (const section of rows.sections) {
          for (const element of section.elements) {
            if (
              element.type === "seat" &&
              element.available_services.length > 0
            ) {
              return true;
            }
          }
        }
      }
    }
  }

  return false;
}
;
import "/Users/igordepaula/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";